import ShareBlockModal from './ShareBlockModal';

export default ShareBlockModal;
